<div style="text-align: center;">
	<h3>Sorry!  There was an error loading the requested page.</h3>
	<p id="directLink">
			<a href="/callback/cancel">Click here</a> to close this page and try again.
	</p>
</div>